import { render, staticRenderFns } from "./MhTableEditable.vue?vue&type=template&id=2f9472c7&scoped=true"
import script from "./MhTableEditable.vue?vue&type=script&lang=js"
export * from "./MhTableEditable.vue?vue&type=script&lang=js"
import style0 from "./MhTableEditable.vue?vue&type=style&index=0&id=2f9472c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9472c7",
  null
  
)

export default component.exports